import { FilterTypes, ServiceStatus } from "../../../types";
/**
 * Default segment filters used globally by the Segments module.
 * Fetches DRAFT, READY, and EXPIRED segments (excludes ARCHIVED).
 */
export const DEFAULT_SEGMENT_FILTERS = {
    where: [
        {
            type: FilterTypes.IN,
            value: [ServiceStatus.DRAFT, ServiceStatus.READY, ServiceStatus.EXPIRED],
            field: "status"
        }
    ]
};
//# sourceMappingURL=constants.js.map